import { render, staticRenderFns } from "./cancelacion.vue?vue&type=template&id=4999f41c&"
import script from "./cancelacion.vue?vue&type=script&lang=js&"
export * from "./cancelacion.vue?vue&type=script&lang=js&"
import style0 from "./cancelacion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports